<ion-tabs>
  <ion-tab-bar slot="bottom" class="tab-bar">

    <ion-tab-button tab="today">
      <ion-icon src="assets/icons/today.svg"></ion-icon>
      <ion-label>Retos</ion-label>
    </ion-tab-button>

    <!-- Explore: siempre disponible, la lógica va en onExploreClick -->
    <ion-tab-button
      tab="explore"
      (click)="onExploreClick($event)"
    >
      <ion-icon src="assets/icons/explore.svg"></ion-icon>
      <ion-label>Explorar</ion-label>
    </ion-tab-button>

    <!-- Global: SOLO ADMIN -->
    <ion-tab-button
      *ngIf="isAdmin()"
      tab="global"
    >
      <ion-icon src="assets/icons/global.svg"></ion-icon>
      <ion-label>Global</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="profile">
      <ion-icon src="assets/icons/profile.svg"></ion-icon>
      <ion-label>Perfil</ion-label>
    </ion-tab-button>

  </ion-tab-bar>
</ion-tabs>
